import React from "react";
import "./Msalrystructure.css";
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const salaryData = [
  { name: "CTC", monthly: "26,667", annual: "3,20,000" },
  { name: "Basic", monthly: "5,333", annual: "64,000" },
  { name: "HRA", monthly: "2,133", annual: "25,600" },
  { name: "PF Employer", monthly: "693", annual: "8,320" },
  { name: "Gratuity", monthly: "257", annual: "3,078" },
  { name: "Food Coupons", monthly: "2,000", annual: "24,000" },
  { name: "Medical Allowance", monthly: "1,000", annual: "12,000" },
  { name: "Internet Allowances", monthly: "2,500", annual: "30,000" },
  { name: "Telephone Allowance", monthly: "1,000", annual: "12,000" },
  { name: "Group Insurance (Self)", monthly: "600", annual: "7,200" },
  { name: "Leave Travel Allowance", monthly: "1,250", annual: "15,000" },
  { name: "News Paper & Periodicals", monthly: "1,000", annual: "12,000" },
  { name: "ESI Employer", monthly: "0", annual: "0" },
  { name: "Special Allowance", monthly: "9,500", annual: "1,14,002" },
];

const SalaryStructure = () => {
  return (
    <Card className="salary-wrapper">
      <CardContent>
        <Typography className="salary-title">
          Salary Structure
        </Typography>

        <TableContainer component={Paper} className="salary-table">
          <Table>
            <TableHead>
              <TableRow className="salary-head">
                <TableCell>Components</TableCell>
                <TableCell>Monthly (₹)</TableCell>
                <TableCell>Annual (₹)</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {salaryData.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.name}</TableCell>
                  <TableCell>{item.monthly}</TableCell>
                  <TableCell>{item.annual}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Typography className="salary-note">
          * This salary structure is confidential and for internal use only.
        </Typography>
      </CardContent>
    </Card>
  );
};

export default SalaryStructure;
